import { Grid, Typography, Stack, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/Common/Loader';
import CustomBreadcrumb from '../../components/CustomBreadcrumbs/CustomBreadcrumbs';
import DynamicTable from '../../components/Table/Table';
import PageHeader from '../../components/PageHeader/PageHeader';
import {
  fetchMasterData,
  fetchPortfolioOptionsValueWhileEditingCell,
  fetchQualityItemsBannerValue,
  updatePortfolioMasterData
} from './services';

const CheckItems = () => {
  const { state } = useLocation();
  const selectedBu = useSelector((state) => state?.cycle?.selectedBu);
  const [data, setData] = useState([]);
  const [dropdowndata, setDropdowndata] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [qualityCheckData, setQualityCheckData] = useState([]);
  const [checkListColumns, setCheckListColumns] = useState([]);
  const [backdropopen, setbackdropopen] = useState(false);

  const columns = [
    {
      id: 'TPOSKUName',
      label: 'SKU NAME',
      type: 'text',
      editable: false,
      category: 'Product Attributes',
      sticky: true,
      left: 0
    },
    {
      id: 'TPOSKU',
      label: 'POSKU',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    { id: 'UPC', label: 'UPC/GTIN', type: 'text', editable: false, category: 'Product Attributes' },
    {
      id: 'TPOSegmentName',
      label: 'SEGMENT',
      type: 'text',
      editable: true,
      category: 'Product Attributes'
    },

    {
      id: 'TPOSKUClassName',
      label: 'MANUFACTURING CLASS',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'UpdatedTPOSKUBrand',
      label: 'BRAND',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'UpdatedTPOSKUSubBrand',
      label: 'SUB BRAND',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'MaterialGroupSubcategoryName',
      label: 'SUB CATEGORY',
      type: 'text',
      editable: true,
      category: 'Product Attributes'
    },
    {
      id: 'UpdatedTPOSKUFlavor',
      label: 'FLAVOUR',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'UpdatedTPOSKUSize',
      label: 'SIZE',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'PackCount',
      label: 'PACK COUNT',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'PackageTypeName',
      label: 'PACK TYPE',
      type: 'text',
      editable: false,
      category: 'Product Attributes'
    },
    {
      id: 'Innovation',
      label: 'INNOVATION TYPE',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'LaunchPeriodValue',
      label: 'LAUNCH PERIOD (YYYYPP)',
      type: 'text',
      editable: false,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'DiscontinuedPeriodValue',
      label: 'DISCONTINUED PERIOD (YYYYPP)',
      type: 'text',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'HoldFlag',
      label: 'HOLD FLAG',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'StrategicImportance',
      label: 'STRATEGIC IMPORTANCE',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'MustCarryList',
      label: 'MUST CARRY FLAG',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'BrandStrategy',
      label: 'BRAND STRATEGY',
      type: 'text',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'SupplyChainComplexity',
      label: 'SUPPLY CHAIN COMPLEXITY',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },
    {
      id: 'ChannelImportance',
      label: 'CHANNEL IMPORTANCE',
      type: 'dropdown',
      editable: true,
      category: 'Lifecycle & Importance Factors'
    },

    { id: 'CurrentYearRevenue', label: 'CY REVENUE', type: 'number', editable: false },
    { id: 'LastYearRevenue', label: 'LY REVENUE', type: 'number', editable: false },
    { id: 'RevenueGrowth', label: 'REVENUE GROWTH %', type: 'number', editable: false },
    { id: 'CurrentYearUnits', label: 'CY UNITS', type: 'number', editable: false },
    { id: 'LastYearUnits', label: 'LY UNITS', type: 'number', editable: false },
    { id: 'UnitGrowth', label: 'UNIT GROWTH %', type: 'number', editable: false },
    { id: 'CurrentYearProfitPercentage', label: 'CY PROFIT %', type: 'number', editable: false },
    { id: 'CYWastePercentage', label: 'CY WASTE %', type: 'number', editable: false },
    { id: 'LastUpdatedEmailIDWebapp', label: 'LAST MODIFIED BY', type: 'text', editable: false },
    { id: 'LastUpdatedTimestamp', label: 'LAST MODIFIED ON', type: 'date', editable: false }
  ];

  const qualityCheckColumns = {
    skuId: 'SKU ID',
    segment: 'Segment',
    subCategory: 'Sub Category',
    mustCarryFlag: 'MUST CARRY FLAG',
    strategicImportance: 'STRATEGIC IMPORTANCE',
    supplyChainComplexity: 'SUPPLY CHAIN COMPLEXITY',
    channelImportance: 'CHANNEL IMPORTANCE',
    innovationType: 'INNOVATION TYPE',
    brandStrategy: 'BRAND STRATEGY',
    discontinueDate: 'DISCONTINUED PERIOD', //discontinuedDate is not present in columns
    tposku: 'PO SKU'
  };

  const breadcrumbs = [{ label: 'Back', link: '/portfolio/master-data' }];

  const getMasterData = async () => {
    setIsTableLoading(true);
    setbackdropopen(true);
    const allData = [];
    let pageNumber = 0;
    const dataLimitPerPage = 3500;
    let shouldContinue = true;
    try {
      while (shouldContinue) {
        const { data3 } = await fetchMasterData({
          BusinessUnitName: selectedBu,
          PageNumber: pageNumber,
          PageSize: dataLimitPerPage
        });
        allData.push(...data3);
        // Check if the data length is less than the limit, stop if so
        if (data3.length < dataLimitPerPage) {
          shouldContinue = false;
        } else {
          pageNumber++;
        }
      }
      setData(allData);
      const dropDownContent = await fetchPortfolioOptionsValueWhileEditingCell();

      const result = dropDownContent.reduce((acc, { columnName, columnValue }) => {
        if (!acc[columnName]) {
          acc[columnName] = [];
        }

        acc[columnName].push(columnValue);
        return acc;
      }, {});
      let resultColumns = columns.map((col) => {
        if (Object.hasOwn(result, col.id)) {
          return { ...col, options: ['', ...result[col.id]] };
        }
        return col;
      });
      setCheckListColumns(resultColumns);

      setDropdowndata(result);
      return allData;
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setbackdropopen(false);
      setIsTableLoading(false);
    }
  };

  const getQualityCheckData = async () => {
    try {
      const response = await fetchQualityItemsBannerValue(selectedBu);
      setQualityCheckData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (selectedBu) {
      getMasterData();
      getQualityCheckData();
    }
  }, [selectedBu]);

  const handleSaveChanges = async (tableData) => {
    setIsTableLoading(true);
    try {
      const val = await updatePortfolioMasterData(tableData);
      if (val == 'Portfolio Master data has been updated Successfully!!') {
        getMasterData();
      }

      const response = await fetchQualityItemsBannerValue(selectedBu);
      setQualityCheckData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsTableLoading(false);
    }
  };

  return (
    <>
      <Grid container gap="1rem" sx={{ padding: '24px', width: '100%' }} direction={'column'}>
        {/* breadcrumbs */}
        <Grid item>
          <CustomBreadcrumb breadcrumbs={breadcrumbs} />
        </Grid>

        <PageHeader
          pageHeader="Review Items"
          cardHeaderDetails={state.timeframe}
          showBu
          showTimeFrame
        />

        <Grid container spacing={2} sx={{ maxHeight: '70vh' }}>
          <Grid item sx={{ width: '80%' }}>
            <Box
              component="section"
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#FBFCFE',
                boxShadow: '4px 0px 24px -2px #005CBC14',
                height: '100%'
              }}>
              <DynamicTable
                originalColumns={checkListColumns}
                originalData={data}
                tableName="Review Items Table"
                isTableLoading={isTableLoading}
                isSearch
                isColumnVisibleFilter
                isColumnFilter
                isGlobalFilter
                isEditable
                density="small"
                onDownload={() => {}}
                onDelete={() => {}}
                onSave={(data) => handleSaveChanges(data)}
                dropdowndata={dropdowndata}
                isCollapseButton={false}
              />
            </Box>
          </Grid>

          <Grid
            item
            sx={{
              width: '20%'
            }}>
            <Box
              key={'label_box'}
              component="section"
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#FBFCFE',
                boxShadow: '4px 0px 24px -2px #005CBC14',
                height: '100%'
                // overflowY: "scroll"
              }}>
              <Box sx={{ padding: '16px 16px 0px 8px' }} key={'label_box_div'}>
                <Typography variant="h6" fontWeight={700}>
                  Quality Check
                </Typography>
              </Box>

              <Box>
                {qualityCheckData &&
                  Object.entries(qualityCheckData)
                    .filter(([key, value]) => key !== 'upc' && key !== 'launchPeriod') //upc & launchPeriod values filtered out as requested
                    .map(([key, value]) => {
                      return (
                        <>
                          <Typography sx={{ fontSize: '14px', lineHeight: '20px' }}>
                            <Stack
                              key={key}
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              gap="8px"
                              sx={{
                                lineHeight: '20px',
                                padding: '8px',
                                Border: '0px, 0px, 1px, 0px',
                                margin: '8px 0'
                              }}>
                              <Stack direction="row" alignItems="left" sx={{ fontWeight: 500 }}>
                                {qualityCheckColumns[key] && qualityCheckColumns[key].toUpperCase()}
                              </Stack>
                              <Stack
                                direction="row"
                                alignItems="right"
                                sx={{
                                  color: value < 100 ? '#D40020' : '#008553',
                                  fontWeight: 700
                                }}>
                                {value + '%'}
                              </Stack>
                            </Stack>
                          </Typography>
                        </>
                      );
                    })}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Loader backdropopen={backdropopen} />
    </>
  );
};

export default CheckItems;
